import type { DocumentComponent } from "@/schema/documentComponentSchema";

export const forhaandsvarselDocumentMock: DocumentComponent[] = [
  {
    type: "HEADER_H1",
    key: null,
    title: null,
    texts: ["Varsel om mulig stans av sykepenger"],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: [
      "Du har nå vært sykmeldt i mer enn åtte uker. Da har du plikt til å være i aktivitet.",
    ],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: [
      "Basert på opplysningene NAV har i saken er du ikke i arbeidsrelatert aktivitet, og det er heller ikke dokumentert at du oppfyller vilkårene for unntak fra aktivitetsplikten. Vi vurderer derfor å stanse sykepengene dine fra og med 24. mars 2025.",
    ],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: ["Her kan veilederen skrive fritekst om begrunnelse.."],
  },
  {
    type: "HEADER_H3",
    key: null,
    title: null,
    texts: ["Du kan unngå stans av sykepenger"],
  },
  {
    type: "BULLET_POINTS",
    key: null,
    title: null,
    texts: [
      "(Ikke oppdatert tekst.) Kommer du helt eller delvis tilbake i arbeid, oppfyller du aktivitetsplikten og kan fortsatt få sykepenger. Aktivitet kan dokumenteres med gradert sykmelding eller i søknaden",
      "Gir arbeidsgiveren din en skriftlig begrunnelse for at det ikke er mulig å legge til rette for at du kan jobbe, kan utbetalingen av sykepenger fortsette.",
      "Går det fram av sykmeldingen at du er for syk til å arbeide, får du fortsatt sykepenger.",
    ],
  },
  {
    type: "HEADER_H3",
    key: null,
    title: null,
    texts: ["Gi oss tilbakemelding"],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: [
      "Vi ber om tilbakemelding fra deg, arbeidsgiveren din, eller den som har sykmeldt deg innen 24. mars. Etter denne datoen vil NAV vurdere å stanse sykepengene dine.",
    ],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: [
      "Kontakt oss gjerne på nav.no/skriv-til-oss eller telefon 55 55 33 33.",
    ],
  },
  {
    type: "HEADER_H3",
    key: null,
    title: null,
    texts: ["Lovhjemmel"],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: ["Aktivitetsplikten er beskrevet i folketrygdloven § 8-8 2.ledd."],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: [
      "«Medlemmet har plikt til å være i arbeidsrelatert aktivitet, jf. § 8-7 a første ledd og arbeidsmiljøloven § 4-6 første ledd, så tidlig som mulig, og senest innen 8 uker. Dette gjelder ikke når medisinske grunner klart er til hinder for slik aktivitet, eller arbeidsrelaterte aktiviteter ikke kan gjennomføres på arbeidsplassen.»",
    ],
  },
  {
    type: "PARAGRAPH",
    key: null,
    title: null,
    texts: ["Med vennlig hilsen", "F_Z991085 E_Z991085", "NAV"],
  },
];
